var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmbulance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2676_32128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5156 22C18.8963 22 20.0156 20.8807 20.0156 19.5C20.0156 18.1193 18.8963 17 17.5156 17C16.1349 17 15.0156 18.1193 15.0156 19.5C15.0156 20.8807 16.1349 22 17.5156 22Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51563 22C7.89634 22 9.01563 20.8807 9.01563 19.5C9.01563 18.1193 7.89634 17 6.51563 17C5.13491 17 4.01562 18.1193 4.01562 19.5C4.01562 20.8807 5.13491 22 6.51563 22Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96484 20H15.0648",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18813 9.59776C7.18813 10.4357 8.17028 11.2695 9.0082 11.2695C9.84612 11.2695 10.8438 10.4357 10.8438 9.59776C10.8438 8.75983 9.29498 6.53773 9.0082 6.25095C8.72591 6.53773 7.18813 8.75983 7.18813 9.59776Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06562 19.9992H1.01562L1.01563 13.9102H14.5156H21.0156C22.1219 13.9102 23.0156 14.5904 23.0156 15.4324V19.9992H19.9656",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5125 13.9109L19.8878 7.02764C19.6475 6.00704 18.9439 5.31641 18.1429 5.31641H15.8203V13.9109",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7643 3.60938H2.07322C1.48713 3.60938 1.01562 4.03988 1.01562 4.575V12.9438C1.01562 13.4789 1.48713 13.9094 2.07322 13.9094H14.7643C15.3504 13.9094 15.8219 13.4789 15.8219 12.9438V4.575C15.8219 4.03988 15.3504 3.60938 14.7643 3.60938Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3617 5.31641L17.9305 3.81641H17.0992L16.668 5.31641",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2676_32128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.015625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/ambulance.ddad45ba3226571dbf3ffd69579f7798.svg";
export { ForwardRef as ReactComponent };